export const autofillG4ComboardId = () => (value: string) => {
  return value.match(/^\d{9}$/) ? `${value}-999999999` : value;
};
